import { apiClient } from "./httpClient";
import { unwrapList, unwrapMeta } from "./response";

export const auditApi = {
  async list(params = {}) {
    const response = await apiClient.get("/audit-logs", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  }
};
